export default __webpack_public_path__ + "static/B0303-0d78dfccd03bb0fb5e50361981b97342.png";